import { toast as sonnerToast } from 'sonner';

export type ToastVariant = 'default' | 'success' | 'error' | 'info' | 'warning';

export interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const toast = {
  default: (options: ToastOptions | string) => {
    if (typeof options === 'string') {
      sonnerToast(options, {
        position: 'top-right',
      });
    } else {
      sonnerToast(options.title, {
        description: options.description,
        duration: options.duration,
        action: options.action,
        position: 'top-right',
        classNames: {
          description: '!text-black',
        },
      });
    }
  },

  success: (options: ToastOptions | string) => {
    if (typeof options === 'string') {
      sonnerToast.success(options, {
        position: 'top-right',
      });
    } else {
      sonnerToast.success(options.title, {
        description: options.description,
        duration: options.duration,
        action: options.action,
        position: 'top-right',
        classNames: {
          description: '!text-black',
        },
      });
    }
  },

  error: (options: ToastOptions | string) => {
    if (typeof options === 'string') {
      sonnerToast.error(options, {
        position: 'top-right',
      });
    } else {
      sonnerToast.error(options.title, {
        description: options.description,
        duration: options.duration,
        action: options.action,
        position: 'top-right',
        classNames: {
          description: '!text-black',
        },
      });
    }
  },

  info: (options: ToastOptions | string) => {
    if (typeof options === 'string') {
      sonnerToast.info(options, {
        position: 'top-right',
      });
    } else {
      sonnerToast.info(options.title, {
        description: options.description,
        duration: options.duration,
        position: 'top-right',
        action: options.action,
        classNames: {
          description: '!text-black',
        },
      });
    }
  },

  warning: (options: ToastOptions | string) => {
    if (typeof options === 'string') {
      sonnerToast.warning(options, {
        position: 'top-right',
      });
    } else {
      sonnerToast.warning(options.title, {
        description: options.description,
        position: 'top-right',
        duration: options.duration,
        action: options.action,
        classNames: {
          description: '!text-black',
        },
      });
    }
  },

  dismiss: (toastId?: string | number) => {
    sonnerToast.dismiss(toastId);
  },

  loading: (message: string) => {
    return sonnerToast.loading(message);
  },

  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    }
  ) => {
    return sonnerToast.promise(promise, messages);
  },
};

export { toast };
